(() => {
  const removeIcon = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  function enhanceRemoveButtons(root = document) {
    root.querySelectorAll('m-cart-remove-button .m-cart-item__remove').forEach((button) => {
      if (!button.classList.contains('gc-remove-icon')) {
        button.classList.add('gc-remove-icon');
        button.setAttribute('aria-label', 'Remove item from cart');
        button.setAttribute('title', 'Remove item');
        button.innerHTML = removeIcon;
      }

      if (document.body.classList.contains('template-cart')) {
        const item = button.closest('.m-cart-item');
        const removeControl = button.closest('m-cart-remove-button');
        let actionColumn = item?.querySelector('.gc-cart-action');
        if (item && !actionColumn) {
          actionColumn = document.createElement('div');
          actionColumn.className = 'gc-cart-action';
          const foxkit = item.querySelector('foxkit-incart-upsell');
          item.insertBefore(actionColumn, foxkit || null);
        }
        if (removeControl && actionColumn && removeControl.parentElement !== actionColumn) {
          actionColumn.appendChild(removeControl);
        }
      }
    });
  }

  function enhanceCartColumns() {
    if (!document.body.classList.contains('template-cart')) return;
    document.querySelectorAll('.m-cart__header--wrapper').forEach((header) => {
      if (header.querySelector('.gc-cart-action--header')) return;
      const action = document.createElement('div');
      action.className = 'gc-cart-action gc-cart-action--header';
      action.textContent = 'Action';
      header.appendChild(action);
    });
  }

  function openCartDrawer(cartLink) {
    const drawer = document.querySelector('m-cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open(cartLink);
      return;
    }
    drawer.classList.add('m-cart-drawer--active');
    drawer.style.setProperty('--m-bg-opacity', '0.5');
    drawer.style.setProperty('--translate-x', '0');
    document.documentElement.classList.add('prevent-scroll');
  }

  function forceCartDrawer(event) {
    const cartLink = event.target.closest('a.m-cart-icon-bubble, a[href$="/cart"].m-cart-icon-bubble');
    if (!cartLink || document.body.classList.contains('template-cart')) return;
    const drawer = document.querySelector('m-cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openCartDrawer(cartLink);
  }

  function prepareCartDrawerLinks() {
    if (document.body.classList.contains('template-cart')) return;
    document.querySelectorAll('a.m-cart-icon-bubble').forEach((cartLink) => {
      if (cartLink.dataset.gcDrawerLink === 'true') return;
      cartLink.dataset.gcDrawerLink = 'true';
      cartLink.setAttribute('href', '#cart-drawer');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        openCartDrawer(cartLink);
      }, true);
    });
  }

  function addDescriptionGallery() {
    if (!document.body.classList.contains('template-product')) return;
    const description = document.querySelector('.m-product-description');
    if (!description || description.querySelector('.gc-description-gallery')) return;

    const productTitle = document.querySelector('h1')?.textContent?.trim() || 'Product image';
    const urls = [];
    document.querySelectorAll('.m-media-gallery__list img, .m-product-media--slider__images img').forEach((img) => {
      const url = img.currentSrc || img.src || img.dataset.src;
      if (url && !urls.includes(url)) urls.push(url);
    });

    const chosen = urls.slice(0, 4);
    if (!chosen.length) return;

    const gallery = document.createElement('div');
    gallery.className = 'gc-description-gallery';
    gallery.setAttribute('aria-label', `${productTitle} gallery`);
    chosen.forEach((url, index) => {
      const item = document.createElement('figure');
      item.className = 'gc-description-gallery__item';
      const image = document.createElement('img');
      image.src = url;
      image.alt = `${productTitle} – view ${index + 1}`;
      image.loading = 'lazy';
      image.decoding = 'async';
      item.appendChild(image);
      gallery.appendChild(item);
    });
    description.appendChild(gallery);
  }

  function markRecentlyViewedSection(root = document) {
    const candidates = root.querySelectorAll?.('h1, h2, h3, h4, .m-section__heading, .section__heading') || [];
    candidates.forEach((heading) => {
      const label = (heading.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label !== 'recently viewed products' && label !== 'recently viewed') return;

      let section = heading.closest('section, .shopify-section');
      if (!section || !section.querySelector('.m-product-card, [class*="product-card"], .swiper-slide')) {
        let parent = heading.parentElement;
        while (parent && parent !== document.body) {
          if (parent.querySelector('.m-product-card, [class*="product-card"], .swiper-slide')) {
            section = parent;
            break;
          }
          parent = parent.parentElement;
        }
      }
      section?.classList.add('gc-recently-viewed-section');
    });
  }

  function markDynamicDropdownMenus(root = document) {
    const topLinks = root.querySelectorAll?.('.m-menu > .m-menu__item > .m-menu__link, .m-menu__item--level-1 > .m-menu__link') || [];
    topLinks.forEach((link) => {
      const label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label !== 'shop' && label !== 'all brands') return;
      link.closest('.m-menu__item')?.classList.add('gc-dynamic-dropdown');
    });
  }

  async function prepareQuickViewProduct(button) {
    const form = button.closest('form[data-product-handle], form[data-type="add-to-cart-form"]') || button.closest('form');
    const handle = form?.dataset.productHandle;
    if (!form || !handle) return null;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return null;
      const product = await response.json();
      const selectedVariantId = Number(form.querySelector('[name="id"]')?.value);
      if (selectedVariantId) {
        const selected = product.variants?.find((variant) => Number(variant.id) === selectedVariantId);
        if (selected) product.selected_or_first_available_variant = selected;
      }
      window.ES_INITIAL_PRODUCT = product;
      window.ES_SECTION_PRODUCT_HANDLE = handle;
      window.ES_SECTION_PRODUCT = product;
      window.ES_CLOSEST_FORM = form;
      window.ES_QUICK_VIEW_VARIANT_ID = selectedVariantId || product.variants?.[0]?.id;
      return { product, form };
    } catch (error) {
      console.warn('Unable to prepare COD quick view product.', error);
      return null;
    }
  }

  function findOrCreateEasySellBridge(form) {
    if (!form) return null;
    let launcher = form.querySelector('.gc-easysell-quickview-bridge');
    if (launcher) return launcher;

    launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'es-popup-button-overwrite gc-easysell-quickview-bridge';
    launcher.setAttribute('aria-hidden', 'true');
    launcher.tabIndex = -1;
    launcher.style.position = 'fixed';
    launcher.style.left = '-99999px';
    launcher.style.top = '-99999px';
    launcher.style.width = '1px';
    launcher.style.height = '1px';
    launcher.style.opacity = '0';
    form.appendChild(launcher);
    return launcher;
  }

  async function openQuickViewCod(button) {
    if (button.dataset.gcCodLoading === 'true') return;
    button.dataset.gcCodLoading = 'true';
    button.setAttribute('aria-busy', 'true');
    let message = button.parentElement.querySelector('.gc-cod-message');
    if (!message) {
      message = document.createElement('p');
      message.className = 'gc-cod-message';
      message.setAttribute('role', 'alert');
      button.parentElement.appendChild(message);
    }
    message.textContent = '';
    try {
      const prepared = await prepareQuickViewProduct(button);
      if (!prepared) throw new Error('Product could not be loaded. Please try again.');
      const selected = prepared.product.variants?.find(v => String(v.id) === String(prepared.form.querySelector('[name="id"]')?.value));
      if (!selected || !selected.available) throw new Error('Please select an available size.');
      const quantity = prepared.form.querySelector('[name="quantity"]');
      if (quantity && !quantity.checkValidity()) {
        quantity.reportValidity();
        return;
      }
      // EasySell exposes this launcher after its own eligibility checks.
      if (typeof window.openTysloForm !== 'function' && typeof window.ES_ENABLE_FORM === 'function') {
        await window.ES_ENABLE_FORM();
      }
      if (typeof window.openTysloForm !== 'function') {
        throw new Error('Cash on Delivery is currently unavailable. Please try again shortly.');
      }
      window.ES_CLOSEST_FORM = prepared.form;
      await window.openTysloForm();
    } catch (error) {
      message.textContent = error.message || 'Unable to open Cash on Delivery. Please try again.';
    } finally {
      button.dataset.gcCodLoading = 'false';
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.gc-quickview-cod-button');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openQuickViewCod(button);
  }, true);

  document.addEventListener('click', forceCartDrawer, true);

  document.addEventListener('DOMContentLoaded', () => {
    enhanceRemoveButtons();
    enhanceCartColumns();
    addDescriptionGallery();
    prepareCartDrawerLinks();
    markRecentlyViewedSection();
    markDynamicDropdownMenus();
  });
  document.addEventListener('cart:updated', () => {
    enhanceRemoveButtons();
    enhanceCartColumns();
  });
  document.addEventListener('quick-view:loaded', () => enhanceRemoveButtons());

  if (document.readyState !== 'loading') prepareCartDrawerLinks();

  let mutationTimer;
  new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => [...mutation.addedNodes].some((node) => {
      if (node.nodeType !== 1) return false;
      return node.matches?.('m-cart-remove-button, m-cart-drawer, .m-menu, .shopify-section') ||
        node.querySelector?.('m-cart-remove-button, m-cart-drawer, .m-menu, .m-section__heading');
    }));
    if (!relevant) return;
    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(() => {
      enhanceRemoveButtons();
      markRecentlyViewedSection();
      markDynamicDropdownMenus();
    }, 120);
  }).observe(document.body, { childList: true, subtree: true });
})();
